import SelectBox from 'devextreme-react/select-box';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import { useContext, } from 'react';
import { Link } from 'react-router-dom';
import { TextBoxWithDelay } from '../../../../components';
import { useAuth } from '../../../../contexts/auth';
import { Field, Panel } from '../../../../layouts';
import { CompanyTypes } from '../../../../types/enums';
import { formatShortDate } from '../../../../utils/date-utils';
import { PurchaseOrderContext } from '../../purchase-order/context/PurchaseOrderContext';
import { POCreditMemoContext } from '../context/POCreditMemoContext';

export default function CreditMemoInformationPanel() {

	const { order } = useContext(PurchaseOrderContext);
	const { creditMemo, modify } = useContext(POCreditMemoContext);

	const { user } = useAuth();
	const isManufacturer = user?.companyTypeId === CompanyTypes.MFR;
	const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;
	const urlFolder = isManufacturer ? "manufacturer" : isServiceProvider ? "service-provider" : "distributor";

	return (
		<>
			<Panel
				header={'Credit Memo Information'}
			>
				{
					creditMemo.details.creditMemoID ?
						<>
							<Field label={'Credit Memo Number'} >{creditMemo.details.creditMemoNumber}</Field>
							<Field label={'Invoice'} >{creditMemo.details.invoiceNumber}</Field>
							<Field label={'Invoice Date'} >{formatShortDate(creditMemo.details.invoiceDate)}</Field>
							<Field label={isServiceProvider ? 'Distributor' : 'Service Provider'} >
								{order.details.distributor.companyName}
							</Field>
							<Field label={'Phone'} >{order.details.distributor.phone}</Field>
							<Field label={'Fax'}>{order.details.distributor.fax}</Field>
							<Field label={'PO Number'} >
								<Link to={`/${urlFolder}/purchase-order/${order.details.purchaseOrderID}`}>{order.details.poNumber}</Link>
							</Field>
						</>
						:
						<>
							<Field label={'Credit Memo Number'}>
								<TextBoxWithDelay
									className="required"
									value={creditMemo.details.creditMemoNumber}
									textChangeDelay={500} onTextChanged={(value) => {
										modify({ ...creditMemo.details, creditMemoNumber: value });
									}}>
									<Validator>
										<RequiredRule></RequiredRule>
									</Validator>
								</TextBoxWithDelay>
							</Field>
							<Field label={'Invoice'} >
								<SelectBox
									value={creditMemo.details.poInvoiceID}
									dataSource={order.details.invoices}
									valueExpr="poInvoiceID"
									displayExpr="invoiceNumber"
									showClearButton={true}
									onValueChanged={(e) => {
										const invoiceDate = order.details.invoices.find(x => x.poInvoiceID === e.value)?.invoiceDate;
										modify({ ...creditMemo.details, poInvoiceID: e.value, invoiceDate: invoiceDate });
									}}
								/>
							</Field>
							<Field label={'Invoice Date'} >{formatShortDate(creditMemo.details.invoiceDate)}</Field>
							<Field label={'Distributor'} >{order.details.distributor.companyName}</Field>
							<Field label={'Phone'} >{order.details.distributor.phone}</Field>
							<Field label={'Fax'} >{order.details.distributor.fax}</Field>
							<Field label={'PO Number'} >
								<Link to={`/${urlFolder}/purchase-order/${order.details.purchaseOrderID}`}>{order.details.poNumber}</Link>
							</Field>
						</>
				}
			</Panel>
		</>
	);
}
